var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"d-block my"},[_c('div',{staticClass:"d-inline-flex flex-align-center cursor-pointer"},[_c('div',{staticClass:"bg-white rounded-full",staticStyle:{"width":"0.5rem","height":"0.5rem"},style:({
                transform: `scale(${_vm.isActive ? 2 : 1})`,
                transition: `transform ${_vm.animationDuration}ms ease-in-out`,
            })}),_vm._v(" "),_c('div',{staticStyle:{"transform-origin":"0 50% 0","margin-left":"2.5rem"},style:({
                opacity: _vm.showTitle ? 1 : 0,
                transform: `scale(${_vm.isActive ? 1.5 : 1})`,
                transition: `opacity ${_vm.animationDuration}ms ease-in-out, transform ${_vm.animationDuration}ms ease-in-out`,
            })},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }